import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import memoizeOne from 'memoize-one';
import { range } from '@elliemae/ds-utilities/utils';
import DSComboBox, { components } from '@elliemae/ds-basic/form/ComboBox';

var SingleValue = function SingleValue(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(components.SingleValue, props, children, " ", /*#__PURE__*/React.createElement("span", null, "per page"));
};

var generateOption = function generateOption(value) {
  return {
    value: value,
    label: value
  };
};

var getOptions = memoizeOne(function (step, min, max) {
  var options = range(min, max + step, step).map(generateOption);
  return min === 0 ? options.slice(1, options.length) : options;
});

function PerPageDropdown(_ref2) {
  var _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? 0 : _ref2$min,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? 100 : _ref2$max,
      _ref2$step = _ref2.step,
      step = _ref2$step === void 0 ? 5 : _ref2$step,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? 0 : _ref2$value,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {
    return null;
  } : _ref2$onChange;
  var options = getOptions(step, min, max);
  return /*#__PURE__*/React.createElement(DSComboBox, {
    className: "per-page-dropdown",
    components: {
      SingleValue: SingleValue
    },
    containerProps: {
      'data-testid': 'per-page-dropdown'
    },
    maxOptions: 10,
    onChange: onChange,
    options: options,
    searchable: false,
    value: value
  });
}

export default PerPageDropdown;
//# sourceMappingURL=PerPageDropdown.js.map
